import {
  FINISH_LOADING_APPLICATION, RLTD_ACC_NOT_AVL,
  SET_USER_DETAILS,
  START_LOADING_APPLICATION,
} from "../action";
import { getUserDetailsFromUUC } from "../api/api";
import { getLocale } from "../utilities/utils";
import { fetchRelatedAccounts } from "./get-dealer-account-details";
import { loadTranslatedTexts } from "./load-translated-texts";

export function getUserDetails(userId) {
  return async (dispatch) => {
    dispatch({ type: START_LOADING_APPLICATION });
    try {
      const userData = await getUserDetailsFromUUC(userId);
      if(userData) {
        dispatch({type: SET_USER_DETAILS, payload: userData});
      }else{
        dispatch({ type: RLTD_ACC_NOT_AVL });
        dispatch({ type: FINISH_LOADING_APPLICATION });
      }
      if (userData?.dealerAccountId) {
        dispatch(fetchRelatedAccounts(userData, true));
      }
      dispatch(loadTranslatedTexts(getLocale(userData)));
    } catch (error) {
      console.error("Error fetching user details:", error);
      dispatch({type: RLTD_ACC_NOT_AVL});
      dispatch({ type: FINISH_LOADING_APPLICATION });
    } finally {
      dispatch({ type: FINISH_LOADING_APPLICATION });
    }
  };
}
